import React from "react";
import { Flex, Box, Text } from "rebass";
import { MainButton } from "./MainButton/MainButton";
import { getLocalizedString } from "../utils";
import { theme } from "../utils/theme";
import Alert from "../icons/Alert";

const VersionUpdateModal = ({
  isOpen,
  currentVersion,
  newVersion,
  onUpdate,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-5">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full max-h-screen overflow-auto">
        <Flex flexDirection="column" alignItems="center" p={4}>
          {/* Alert Icon */}
          <Box mb={3}>
            <Alert style={{ width: 48, height: 48, color: theme.yellow }} />
          </Box>

          {/* Title */}
          <Text
            fontSize={theme.textBig}
            fontWeight="bold"
            color={theme.black}
            textAlign="center"
            mb={3}
          >
            {getLocalizedString("NEW_VERSION_AVAILABLE") ||
              "Nuova versione disponibile"}
          </Text>

          {/* Version Info */}
          <Box textAlign="center" mb={4}>
            <Text
              fontSize={theme.textMedium}
              color={theme.black}
              mb={2}
              lineHeight="1.4"
            >
              {getLocalizedString("VERSION_UPDATE_MESSAGE") ||
                "È disponibile una nuova versione dell'applicazione"}
            </Text>

            <Text
              fontSize={theme.textSmall}
              color={theme.darkGrey}
              fontWeight="500"
            >
              {getLocalizedString("FROM_VERSION") || "Da"}{" "}
              <strong style={{ color: theme.black }}>v{currentVersion}</strong>{" "}
              {getLocalizedString("TO_VERSION") || "a"}{" "}
              <strong style={{ color: theme.green }}>v{newVersion}</strong>
            </Text>
          </Box>

          {/* Update Button */}
          <Box width="100%" maxWidth={280} mb={3}>
            <MainButton
              type="primary"
              label={getLocalizedString("UPDATE_NOW") || "AGGIORNA ORA"}
              onClick={onUpdate}
              height={48}
              size={theme.textMedium}
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                backgroundColor: theme.darkGrey,
                color: theme.white,
              }}
            />
          </Box>

          {/* Info Message */}
          <Text
            fontSize={theme.textSmall}
            color={theme.grey}
            textAlign="center"
            fontStyle="italic"
            lineHeight="1.3"
          >
            {getLocalizedString("UPDATE_WILL_RELOAD") ||
              "L'applicazione verrà ricaricata automaticamente"}
          </Text>
        </Flex>
      </div>
    </div>
  );
};

export default VersionUpdateModal;
